import loadable from '@loadable/component';

export const UserDashboardSavedItemsPageLoadable = loadable(
  () => import('./UserDashboardSavedItemsPage'),
  { resolveComponent: (module) => module.UserDashboardSavedItemsPage },
);
